import axios from 'axios';
import moment from 'moment';
export default class VersionLogs{
  constructor() {
    this.detailsOfUpdate = [];
    this.latestVersion = '';
  }
  async getLogs(api, tokenHeader) {
    await axios.get(process.env.VUE_APP_DEPLOYMENT == 'TEST' ? `${api}versionlogstest` : `${api}versionlogs`, tokenHeader)
      .then(res => {
        this.detailsOfUpdate = res.data.filter(r => {
          r.ContentofRequest = r.ContentofRequest.replace(/(?:\r\n|\r|\n)/g, '<br>');
          r.DateRequested = moment(r.DateRequested).format('YYYY/MM/DD');
          return r;
        }).sort((a, b) => {
          return b.DateRequested - a.DateRequested || b.id - a.id;
        });
        if(this.detailsOfUpdate){
          this.latestVersion = this.detailsOfUpdate[0].Version
        }
      })
  }
}
